<template>
  <div class="views-form">
    <v-card flat tile>
      <div class="mb-4 headline font-weight-bold">Create new view</div>
      <div class="mb-1 subtitle-1 font-weight-bold">View name</div>
      <v-card outlined tile class="mb-6">
        <v-card-text class="py-1">
          <v-text-field v-model="view.name" :rules="nameRulses"></v-text-field>
        </v-card-text>
      </v-card>

      <div class="mb-1 subtitle-1 font-weight-bold">View description</div>
      <v-card outlined tile class="mb-6">
        <v-card-text class="py-1">
          <v-textarea flat tile solo v-model="view.description"></v-textarea>
        </v-card-text>
      </v-card>
      <v-card-actions> </v-card-actions>
    </v-card>
    <v-container fluid>
      <v-row>
        <v-toolbar dark color="grey lighten-3" class="mb-3" flat>
          <v-text-field v-model="search" clearable text hide-details light flat single-line solo color="black"
            prepend-inner-icon="mdi-magnify" label="Search" class="mr-3" style="max-width: 300px"></v-text-field>

          <v-btn-toggle group color="primary" v-model="sortDesc" mandatory>
            <v-btn color="primary" text :value="false">
              <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn color="primary" text :value="true">
              <v-icon>mdi-arrow-down</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-select v-model="categoriesSelected" :items="selectableCategories" item-text="name" item-value="_id"
            label="Select categories" light flat clearable solo hide-details multiple style="max-width: 300px">
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 1">
                <span>{{ item.name }} </span>
              </v-chip>
              <span v-if="index === 1" class="grey--text text-caption">
                (+{{ categoriesSelected.length - 1 }} others)
              </span>
            </template>
          </v-select>
          <v-btn depressed tile color="success" class="ml-4" @click.prevent="addFiltered">Add filtered</v-btn>
          <v-btn depressed tile color="warning" class="ml-4" @click.prevent="removeAll">Remove all</v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="view._id" depressed tile color="primary" width="245" height="60"
            @click.prevent="onUpdateView">Update view</v-btn>
          <v-btn v-else depressed tile color="primary" width="245" height="60" @click.prevent="onCreateView">Save
            view</v-btn>
        </v-toolbar>
      </v-row>
      <v-row>
        <v-col v-if="banners" cols="12" sm="6">
          <v-data-iterator row wrap :items="banners" :page="page" item-key="_id" :loading="!!banners" sort-by="name"
            :sort-desc="sortDesc" :search="search" :custom-filter="customFilter" :custom-sort="sortByCompanyName"
            loading-text :items-per-page.sync="itemsPerPage" :footer-props="{ 'items-per-page-options': [16, 32, 64] }">
            <!-- Content -->

            <template v-slot:default="props">
              <v-row>
                <v-col v-for="banner in props.items" :key="banner._id" cols="auto">
                  <v-card @click="selectBanner(banner)" outlined :ripple="false">
                    <v-card-title primary-title class="px-0">

                      <Tooltip v-model="banner.company.panelStatus" text="API"
                        description="Current status of the campaing from API" />

                      <Tooltip v-model="banner.permission" text="P" description="Advertiser's permission to the publicate his
                        creations" />

                      <Tooltip v-model="banner.promote" text="SATT" description="Show at the top" />
                    </v-card-title>

                    <v-card-text class="pa-1 text-right">
                      <v-hover v-slot="{ hover }">
                        <v-img :src="`${banner.thumb}` | staticFilter" contain width="100%" aspect-ratio="0.5">
                          <div v-if="selectedBanners.includes(banner._id)" class="custom-overlay">
                            <v-icon x-large dark>mdi-check-circle</v-icon>
                          </div>
                          <v-fade-transition>
                            <v-btn fab x-small right color="primary" class="ma-1" v-if="hover && role == 'ADMIN'" :to="{
                              name: 'dashboard.banner.edit',
                              params: { id: banner._id },
                            }">
                              <v-icon small>mdi-square-edit-outline</v-icon>
                            </v-btn>
                          </v-fade-transition>
                        </v-img>
                      </v-hover>
                    </v-card-text>
                    <!-- <v-checkbox
                      color="primary"
                      v-model="selectedBanners"
                      :value="banner._id"
                      label="Select"
                      class="labels"
                      dense
                    ></v-checkbox> -->
                  </v-card>
                </v-col>
              </v-row>

              <!-- </v-fade-transition> -->
            </template>
            <!-- Content -->
          </v-data-iterator>
        </v-col>
        <v-col cols="12" sm="6" class="py-2 grey lighten-3 mt-1">
          <v-data-iterator row wrap :items="showSelectedBanners" :page="page" item-key="_id" loading-text disable-sort
            :items-per-page.sync="itemsPerPage" :footer-props="{ 'items-per-page-options': [16, 32, 64] }">
            <!-- Content -->

            <template v-slot:default="props" class="mt-2">
              <v-row>
                <v-col v-for="banner in props.items" :key="banner._id" cols="auto">
                  <v-card outlined :ripple="false">
                    <v-card-title primary-title class="px-0">

                      <Tooltip v-model="banner.company.panelStatus" text="API"
                        description="Current status of the campaing from API" />

                      <Tooltip v-model="banner.permission" text="P" description="Advertiser's permission to the publicate his
  creations" />

                      <Tooltip v-model="banner.promote" text="SATT" description="Show at the top" />
                    </v-card-title>
                    <v-card-text class="pa-1 text-right">
                      <v-hover v-slot="{ hover }">
                        <v-img :src="`${banner.thumb}` | staticFilter" contain width="100%" aspect-ratio="0.5">
                          <v-fade-transition>
                            <v-btn fab x-small right color="primary" class="ma-1" v-if="hover"
                              @click="removeBanner(banner)">
                              <v-icon small>mdi-close</v-icon>
                            </v-btn>
                          </v-fade-transition>
                        </v-img>
                      </v-hover>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <!-- </v-fade-transition> -->
            </template>
            <!-- Content -->
          </v-data-iterator>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

export default Vue.extend({
  name: "ViewCreate",
  components: {
    Tooltip: () => import("@/components/Dashboard/Tooltip"),
    // Banner: () => import("@/components/Dashboard/BannerThumb")
  },
  props: {
    view: {
      type: Object,
      default: () => new Object(),
    },
  },
  data() {
    return {
      name: null,
      selectedBanners: [],
      description: null,
      itemsPerPageArray: [16, 32, 64],
      itemsPerPage: 16,
      search: "",
      search2: "",
      filter: {},
      sortDesc: false,
      page: 1,
      sortBy: "name",
      categoriesSelected: [],
      filtered: [],
      nameRulses: [(v) => !!v || "Name is required"],
    };
  },
  computed: {
    ...mapGetters(["banners", "role", "topCategories"]),
    selectableCategories() {
      return this.topCategories.reduce((agg, val) => {
        const { _id, name } = val;
        agg.push({ _id, name, header: name });
        val.categories.forEach((cat) => {
          const { _id, name } = cat;
          agg.push({ _id, name });
        });
        return agg;
      }, []);
    },
    showSelectedBanners() {
      return this.selectedBanners.map((sb) =>
        this.banners.find((banner) => banner._id === sb)
      );
    },
    getBannersByCat() {
      // if (this.categoriesSelected.length == 0) return this.banners;
      let banners = this.banners.filter(
        // arr.every(i => arr2.includes(i));
        (banner) => !this.selectedBanners.some((sb) => sb == banner._id)
      );
      if (this.categoriesSelected.length > 0) {
        banners = banners.filter(
          (banner) =>
            this.categoriesSelected.every((cat) =>
              banner.categories.includes(cat)
            )
          // banner.categories.every((cat) =>
          //   banner.categories.includes(cat)
          // )
          // banner.categories.find((cat) =>
          //   this.categoriesSelected.find((se) => se == cat)
          // )
        );
      }
      return banners;
    },
    // showNotSelectedBanners() {
    //   return this.banners.filter(
    //     banner => !this.selectedBanners.includes(banner._id)
    //   );
    // },
    numberOfPages() {
      return Math.ceil(this.banners.length / this.itemsPerPage);
    },
  },
  methods: {
    ...mapActions([
      "fetchBanners",
      "createView",
      "updateView",
      "setSnackbar",
      "fetchViews",
      "fetchAllCategories",
    ]),
    selectBanner(banner) {
      if (this.selectedBanners.includes(banner._id))
        return this.removeBanner(banner);
      const tempBanners = [banner._id, ...this.selectedBanners];
      this.selectedBanners = [...new Set(tempBanners)];
    },
    removeBanner(banner) {
      this.selectedBanners = this.selectedBanners.filter(
        (_id) => _id !== banner._id
      );
    },
    onCreateView() {
      const banners = this.selectedBanners || [];
      const name = this.view.name || "";
      if (name === "")
        return this.setSnackbar({
          text: `View name is required.`,
          color: "secondary",
        });

      if (banners.length == 0)
        return this.setSnackbar({
          text: `Some banners are required.`,
          color: "secondary",
        });

      this.createView({
        name,
        description: this.view.description,
        id: this.view.id,
        banners,
      });

      this.view = {};
      this.$router.push({ name: "dashboard.views" });
    },
    async onUpdateView() {
      this.view.banners = this.selectedBanners;
      const res = await this.updateView(this.view);
      if (res.status == 201) {
        this.setSnackbar({
          text: `View Updated.`,
        });
        this.$router.push({ name: "dashboard.views" });
      }
    },
    customBannerFilter() {
      return true;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    customFilter(items, search) {
      if (search === null) search = "";

      items = this.banners.filter(
        // arr.every(i => arr2.includes(i));
        (banner) => !this.selectedBanners.some((sb) => sb == banner._id)
      );
      if (this.categoriesSelected.length > 0) {
        // items = items.filter(banner =>
        //   banner.categories.some(cat => this.categoriesSelected.includes(cat))
        // );

        const selectedCategories = this.categoriesSelected;
        let helperCat = [...this.topCategories];
        helperCat.forEach((helper) =>
          helper.categories.forEach(
            (helpSub) =>
              (helpSub.selected = selectedCategories.includes(helpSub._id))
          )
        );
        helperCat = helperCat.filter((hc) =>
          hc.categories.some((hcs) => hcs.selected)
        );

        if (selectedCategories.length > 0 && items.length > 0) {
          items = items.filter(
            (banner) =>
              banner.categories &&
              helperCat.every((hCat) =>
                hCat.categories.some(
                  (subCat) =>
                    banner.categories.includes(subCat._id) && subCat.selected
                )
              )
          );
        }
      }

      search = search.toString().toLowerCase();

      if (search.length > 2) {
        items = items.filter(
          (item) =>
            item.company.name
              .toString()
              .toLowerCase()
              .match(search) !== null ||
            (item.tags || "")
              .toString()
              .toLowerCase()
              .match(search) !== null
        );
      }

      this.filtered = items.map((i) => i._id);
      return items;
      //   return value != null && search != null && typeof value === "string";
    },
    compareValues(order) {
      // Use toUpperCase() to ignore character casing
      return (a, b) => {
        const bandA = a.company.name;
        const bandB = b.company.name;

        let comparison = 0;
        if (bandA > bandB) {
          comparison = 1;
        } else if (bandA < bandB) {
          comparison = -1;
        }
        const sortDesc = order ? -1 : 1;

        return comparison * sortDesc;
      };
    },
    sortByCompanyName(items, sortBy, sortDesc) {
      const sorted = items.sort(this.compareValues(sortDesc[0]));

      return sorted;
    },
    addFiltered() {
      const filtered = this.customFilter(this.banners, this.search).map(
        (f) => f._id
      );

      const allBanners = new Set([...filtered, ...this.selectedBanners]);

      // this.selectedBanners =this.selectedBanners.map(selected => filtered.indexOf(selected) == -1 ? selected);
      // const temp = new Set([...this.selectedBanners, ...filtered])
      this.selectedBanners = [...allBanners];
    },
    removeFiltered() {
      const filtered = this.customFilter(this.banners, this.search).map(
        (f) => f._id
      );
      this.selectedBanners = this.selectedBanners.filter(
        (selected) => filtered.indexOf(selected) === -1
      );
    },
    removeAll() {
      this.selectedBanners = this.selectedBanners = new Array();
    },
  },
  async mounted() {
    await this.fetchBanners({});
    await this.fetchAllCategories({});
    await this.fetchViews();

    // console.log(
    //   this.$store.state.view.views.find((v) => v._id === this.$route.params.id)
    // );
    const selectedBanners = this.$store.state.view.views.find(
      (v) => v._id === this.$route.params.id
    );
    this.selectedBanners = selectedBanners.banners.map((b) => b._id);
    // this.view = this.$store.state.view.views.find(
    //   (v) => v._id === this.$route.params.id
    // );

    // if (this.view.banners)
    //   this.view.banners.forEach((banner) =>
    //     this.selectedBanners.push(banner._id)
    //   );
  },
});
</script>

<style lang="scss">
.banners-wrapper {
  display: flex;
}

.custom-overlay {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 128, 0, 0.418);
  display: flex;
  align-items: center;
  justify-content: center;
}

.selectable-banners {
  flex: 1;
}

.choosen-banners {
  flex: 1;
}
</style>
